export const ButtonSound = () => {
  var audio = new Audio(require("../static/sounds/button-click.mp3"));
  audio.play();
};

var audiobg = new Audio(require("../static/sounds/bg.mp3"));
export const BackgroundMusicStart = () => {
  audiobg.addEventListener(
    "ended",
    function () {
      this.currentTime = 0;
      this.play();
    },
    false
  );
  audiobg.volume = 0.2;
  audiobg.loop = true
  audiobg.play();
};

export const BackgroundMusicStop = () => {
  audiobg.pause();
};
